import { render, staticRenderFns } from "./CbmOpportunityCard.vue?vue&type=template&id=4ed19cb0&scoped=true"
import script from "./CbmOpportunityCard.vue?vue&type=script&lang=js"
export * from "./CbmOpportunityCard.vue?vue&type=script&lang=js"
import style0 from "./CbmOpportunityCard.vue?vue&type=style&index=0&id=4ed19cb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed19cb0",
  null
  
)

export default component.exports